export default __webpack_public_path__ + "static/media/icon-love-poppy-active.ccd32b80.png";